import userReducer from '@app/store/slices/userSlice';
import authReducer from '@app/store/slices/authSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import ClockModeSlice from '@app/store/slices/ClockModeSlice';

import pwaReducer from '@app/store/slices/pwaSlice';
import GlobalLoadingSlice from '@app/store/slices/GlobalLoadingSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  globalLoading: GlobalLoadingSlice,
  clock: ClockModeSlice,
};
